<wbo-edit-page #editPage [formGroup]="editPage.formGroup" [title]="model.data.myreportName">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.myreport.edit.formation.settings', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control [(ngModel)]="model.data.myreportName" formControlName="myreportName">
                        </wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <fui-rows>
                            <fui-row>
                                <fui-two-columns>
                                    <fui-column>
                                        <wbo-checkbox-edit-control [(ngModel)]="model.data.publicReport"
                                                                   formControlName="publicReport"></wbo-checkbox-edit-control>

                                    </fui-column>
                                    <fui-column>
                                        <wbo-checkbox-edit-control [(ngModel)]="model.data.myDefault"
                                                                   formControlName="myDefault"></wbo-checkbox-edit-control>
                                    </fui-column>
                                </fui-two-columns>
                            </fui-row>
                            <fui-row>
                                <fui-two-columns>
                                    <fui-column>
                                        <wbo-checkbox-edit-control [(ngModel)]="model.data.emailFlagForNoPages"
                                                                   formControlName="emailFlagForNoPages"></wbo-checkbox-edit-control>
                                    </fui-column>
                                </fui-two-columns>
                            </fui-row>
                        </fui-rows>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.distributionList" [editable]="false"
                                   [entityPath]="'distributionList'"
                                   [removable]="true"
                                   [title]="'wbo.myreport.edit.field-set.distributionList'">
                        <wbo-column field="employee.contact.email"></wbo-column>
                        <wbo-column field="employee.user.firstName"></wbo-column>
                        <wbo-column field="employee.user.lastName"></wbo-column>
                        <wbo-column field="employee.user.name"></wbo-column>
                        <wbo-edit-grid-add-row (onNewSelect)="selectNewEmployee($event)"
                                               (onSearchSelect)="selectEmployee($event)"
                                               [customAdd]="true">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-employee-single-select-edit-control></wbo-employee-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search [searchComponent]="EmployeeSearchPageComponent"
                                                              [searchParams]="employeeSearchFilter">
                                </wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [editComponent]="EmployeeEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.myreport.edit.formation.schedule', formControlNames: ''}">
        <fui-rows formGroupName="scheduleTemplateData">
            <fui-row [label]="'wbo.myreport.edit.field-set.scheduleTime'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-date-edit-control [(ngModel)]="model.data.scheduleTemplateData.startDate"
                                               (valueChange)="updateValueAndValidityForDates()"
                                               [overrideRequired]="model.data.scheduleTemplateData.pattern.patternType != undefined"
                                               formControlName="startDate"></wbo-date-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-time-edit-control [(ngModel)]="model.data.scheduleTemplateData.startTime"
                                               (valueChange)="updateValueAndValidityForDates()"
                                               [overrideRequired]="model.data.scheduleTemplateData.pattern.patternType != undefined"
                                               formControlName="startTime"></wbo-time-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row [label]="'wbo.myreport.edit.field-set.recurrencePattern'" formGroupName="pattern">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-single-select-edit-control
                                    [(ngModel)]="model.data.scheduleTemplateData.pattern.patternType"
                                    (onClear)="updateValueAndValidityForDates()"
                                    (onSelect)="updateValueAndValidityForDates()"
                                    formControlName="patternType">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="MyreportSchedulePatternData.TYPE_HOURLY"
                                                           label="wbo.myreport.edit.option.pattern_type.hourly">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="MyreportSchedulePatternData.TYPE_DAILY"
                                                           label="wbo.myreport.edit.option.pattern_type.daily">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="MyreportSchedulePatternData.TYPE_WEEKLY"
                                                           label="wbo.myreport.edit.option.pattern_type.weekly">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="MyreportSchedulePatternData.TYPE_MONTHLY"
                                                           label="wbo.myreport.edit.option.pattern_type.monthly">
                                        </wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <!-- HOURS -->
                    <ng-container
                        *ngIf="model.data.scheduleTemplateData.pattern.patternType === MyreportSchedulePatternData.TYPE_HOURLY">
                        <fui-row>
                            <fui-four-columns>
                                <fui-column>
                                    <fui-tandem-field>
                                        <div
                                            class="divLabelEvery">{{'wbo.myreport.edit.message.every' | translate}}</div>
                                        <wbo-numeric-edit-control
                                            [(ngModel)]="model.data.scheduleTemplateData.pattern.hourlyPatternValue"
                                            [overrideRequired]="true" formControlName="hourlyPatternValue">
                                        </wbo-numeric-edit-control>
                                    </fui-tandem-field>
                                </fui-column>
                                <fui-column>
                                    <wbo-single-select-edit-control
                                        [(ngModel)]="model.data.scheduleTemplateData.pattern.hourlyTypePatternValue"
                                        [allowClearSelectionOption]="false"
                                        formControlName="hourlyTypePatternValue">
                                        <wbo-select-options>
                                            <wbo-select-option
                                                [value]="MyreportSchedulePatternData.HOURLY_PATTERN_TYPE_MINUTES"
                                                label="wbo.myreport.edit.option.pattern_hourly_type.minutes">
                                            </wbo-select-option>
                                            <wbo-select-option
                                                [value]="MyreportSchedulePatternData.HOURLY_PATTERN_TYPE_HOURS"
                                                label="wbo.myreport.edit.option.pattern_hourly_type.hours">
                                            </wbo-select-option>
                                        </wbo-select-options>
                                    </wbo-single-select-edit-control>
                                </fui-column>
                            </fui-four-columns>
                        </fui-row>
                    </ng-container>
                    <!-- DAILY -->
                    <ng-container
                        *ngIf="model.data.scheduleTemplateData.pattern.patternType === MyreportSchedulePatternData.TYPE_DAILY">
                        <fui-row>
                            <fui-four-columns>
                                <fui-column>
                                    <wbo-single-select-edit-control
                                        [(ngModel)]="model.data.scheduleTemplateData.pattern.dailyTypePatternValue"
                                        [allowClearSelectionOption]="false"
                                        formControlName="dailyTypePatternValue">
                                        <wbo-select-options>
                                            <wbo-select-option
                                                [value]="MyreportSchedulePatternData.DAILY_PATTERN_TYPE_EVERY_DAY"
                                                label="wbo.myreport.edit.option.pattern_daily_type.everyDay">
                                            </wbo-select-option>
                                            <wbo-select-option
                                                [value]="MyreportSchedulePatternData.DAILY_PATTERN_TYPE_EVERY_WEEK_DAY"
                                                label="wbo.myreport.edit.option.pattern_daily_type.everyWeekday">
                                            </wbo-select-option>
                                        </wbo-select-options>
                                    </wbo-single-select-edit-control>
                                </fui-column>
                                <fui-column>
                                    <wbo-numeric-edit-control
                                        *ngIf="model.data.scheduleTemplateData.pattern.dailyTypePatternValue === MyreportSchedulePatternData.DAILY_PATTERN_TYPE_EVERY_DAY"
                                        [(ngModel)]="model.data.scheduleTemplateData.pattern.dailyPatternNumberDays"
                                        [overrideRequired]="true"
                                        formControlName="dailyPatternNumberDays">
                                    </wbo-numeric-edit-control>
                                </fui-column>
                            </fui-four-columns>
                        </fui-row>
                    </ng-container>
                    <!-- WEEKLY -->
                    <ng-container
                        *ngIf="model.data.scheduleTemplateData.pattern.patternType === MyreportSchedulePatternData.TYPE_WEEKLY">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <wbo-day-of-week-multi-select-edit-control
                                        [(ngModel)]="model.data.scheduleTemplateData.pattern.weeklyDayOfWeek"
                                        [overrideRequired]="true"
                                        formControlName="weeklyDayOfWeek"></wbo-day-of-week-multi-select-edit-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </ng-container>
                    <!-- MONTHLY -->
                    <ng-container
                        *ngIf="model.data.scheduleTemplateData.pattern.patternType === MyreportSchedulePatternData.TYPE_MONTHLY">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <wbo-single-select-edit-control
                                        [(ngModel)]="model.data.scheduleTemplateData.pattern.monthlyFrequencyType"
                                        [allowClearSelectionOption]="false"
                                        formControlName="monthlyFrequencyType">
                                        <wbo-select-options>
                                            <wbo-select-option
                                                [value]="MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF"
                                                label="wbo.myreport.edit.option.monthlyFrequencyType.everyDayOf">
                                            </wbo-select-option>
                                            <wbo-select-option
                                                [value]="MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF_WEEK"
                                                label="wbo.myreport.edit.option.monthlyFrequencyType.everyDayOfWeek">
                                            </wbo-select-option>
                                        </wbo-select-options>
                                    </wbo-single-select-edit-control>
                                </fui-column>
                                <fui-column
                                    *ngIf="model.data.scheduleTemplateData.pattern.monthlyFrequencyType === MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF">
                                    <wbo-numeric-edit-control
                                        [(ngModel)]="model.data.scheduleTemplateData.pattern.monthlyDayOfMonth"
                                        [overrideRequired]="true"
                                        formControlName="monthlyDayOfMonth">
                                    </wbo-numeric-edit-control>
                                </fui-column>
                                <fui-column
                                    *ngIf="model.data.scheduleTemplateData.pattern.monthlyFrequencyType === MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF_WEEK">
                                    <fui-tandem-field>
                                        <wbo-single-select-edit-control
                                            [(ngModel)]="model.data.scheduleTemplateData.pattern.monthlyOccurrence"
                                            [allowClearSelectionOption]="false"
                                            formControlName="monthlyOccurrence">
                                            <wbo-select-options>
                                                <wbo-select-option [value]="'1'"
                                                                   label="wbo.myreport.edit.option.monthlyOccurrence.first">
                                                </wbo-select-option>
                                                <wbo-select-option [value]="'2'"
                                                                   label="wbo.myreport.edit.option.monthlyOccurrence.second">
                                                </wbo-select-option>
                                                <wbo-select-option [value]="'3'"
                                                                   label="wbo.myreport.edit.option.monthlyOccurrence.third">
                                                </wbo-select-option>
                                                <wbo-select-option [value]="'4'"
                                                                   label="wbo.myreport.edit.option.monthlyOccurrence.fourth">
                                                </wbo-select-option>
                                                <wbo-select-option [value]="'L'"
                                                                   label="wbo.myreport.edit.option.monthlyOccurrence.last">
                                                </wbo-select-option>
                                            </wbo-select-options>
                                        </wbo-single-select-edit-control>
                                        <wbo-day-of-week-single-select-edit-control
                                            [(ngModel)]="model.data.scheduleTemplateData.pattern.monthlyDayOfWeek"
                                            [allowClearSelectionOption]="false"
                                            formControlName="monthlyDayOfWeek">
                                        </wbo-day-of-week-single-select-edit-control>
                                    </fui-tandem-field>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <wbo-month-of-year-multi-select-edit-control
                                        [(ngModel)]="model.data.scheduleTemplateData.pattern.monthlySelectedMonths"
                                        [overrideRequired]="true"
                                        formControlName="monthlySelectedMonths"></wbo-month-of-year-multi-select-edit-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </ng-container>
                </fui-rows>
            </fui-row>
            <fui-row *ngIf="hasRecurrencePattern" [label]="'wbo.myreport.edit.field-set.rangeRecurrence'">
                <fui-rows>
                    <fui-row>
                        <fui-four-columns>
                            <fui-column>
                                <wbo-single-select-edit-control
                                    (onSelect)="updateValueAndValidityForDates()"
                                    [(ngModel)]="model.data.scheduleTemplateData.rangeRecurrence"
                                    [allowClearSelectionOption]="false"
                                    formControlName="rangeRecurrence">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="false"
                                                           label="wbo.myreport.edit.option.rangeRecurrence.noEnd">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="true"
                                                           label="wbo.myreport.edit.option.rangeRecurrence.endBy">
                                        </wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                            <fui-column *ngIf="model.data.scheduleTemplateData.rangeRecurrence">
                                <wbo-date-edit-control (valueChange)="updateValueAndValidityForDates()"
                                                       [(ngModel)]="model.data.scheduleTemplateData.finishDate"
                                                       [overrideRequired]="true"
                                                       formControlName="finishDate"></wbo-date-edit-control>
                            </fui-column>
                            <fui-column *ngIf="model.data.scheduleTemplateData.rangeRecurrence">
                                <wbo-time-edit-control (valueChange)="updateValueAndValidityForDates()"
                                                       [(ngModel)]="model.data.scheduleTemplateData.finishTime"
                                                       formControlName="finishTime"></wbo-time-edit-control>
                            </fui-column>
                        </fui-four-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row *ngIf="hasRecurrencePattern" [label]="'wbo.myreport.edit.field-set.exceptionList'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.scheduleTemplateData.exceptions" [editable]="true"
                                       [entityPath]="'scheduleTemplateData.exceptions'" [removable]="true">
                            <wbo-date-column [editable]="true" field="value"></wbo-date-column>
                            <wbo-edit-grid-add-row>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
